import { useForm } from 'react-hook-form';
import { BONE_DECALCIFICATION } from 'components/OrderForm/SamplesFormV2/constants';
import { useEffect } from 'react';
import {
  ORDER_SAMPLES_TABLE_HEADER_NAME,
  serializedTrueFalseOptionsToSelectInput,
} from 'components/OrderForm/constants';
import {
  getBoneDecalcificationFormDefaultValues,
  getGeneratedEmptyTableRows,
  serializeRow,
} from 'components/OrderForm/SamplesFormV2/utilities';

export const useBoneDecalcificationForm = (order) => {
  const methods = useForm({
    defaultValues: getBoneDecalcificationFormDefaultValues(),
  });

  const { setValue } = methods;

  const [bone_decalcification] = methods.watch([BONE_DECALCIFICATION]);

  useEffect(() => {
    if (!order) {
      return;
    }

    setValue(
      BONE_DECALCIFICATION,
      serializedTrueFalseOptionsToSelectInput[order.bone_decalcification],
    );
  }, [order]);

  return {
    bone_decalcification,
    methods,
  };
};

export const useGetImportDataFromExcel = ({ orderUUID, columnsToDisplay }) => {
  const getImportDataFromExcel = ({ samplesData, importRowsData }) => {
    const emptyRows = getGeneratedEmptyTableRows({ orderUUID });
    const [noUUIDRows, withUUIDRows] = importRowsData.reduce(
      (acc, rowData) => {
        acc[+!!rowData[ORDER_SAMPLES_TABLE_HEADER_NAME.sampleUUID]].push(
          rowData,
        );

        return acc;
      },
      [[], []],
    );
    const [newNoUUIDRos, updatedNoUUIDRows] = noUUIDRows.reduce(
      (acc, rowData) => {
        const hasSampleData = samplesData.some(
          (sampleData) =>
            sampleData.name ===
              rowData[ORDER_SAMPLES_TABLE_HEADER_NAME.sampleName] &&
            !sampleData.uuid,
        );

        acc[+hasSampleData].push(rowData);

        return acc;
      },
      [[], []],
    );

    const nextSamplesData = samplesData.map((sampleData) => {
      const importRow = withUUIDRows.find(
        (withUUIDRow) => withUUIDRow['Sample UUID'] === sampleData.uuid,
      );
      const noUUIDRow = updatedNoUUIDRows.find(
        (updatedNoUUIDRow) =>
          sampleData.name === updatedNoUUIDRow['Sample Name'],
      );

      if (importRow) {
        const serializedImportRow = serializeRow({
          columns: columnsToDisplay,
          row: importRow,
        });

        return { ...sampleData, ...serializedImportRow };
      }

      if (noUUIDRow) {
        const serializedUpdatedRow = serializeRow({
          columns: columnsToDisplay,
          row: noUUIDRow,
        });

        return { ...noUUIDRow, ...serializedUpdatedRow };
      }

      return sampleData;
    });

    const serializedNewNoUUIDRos = newNoUUIDRos.map((row) =>
      serializeRow({ columns: columnsToDisplay, row }),
    );

    return [...nextSamplesData, ...serializedNewNoUUIDRos, ...emptyRows];
  };

  return getImportDataFromExcel;
};
